import ShowChartIcon from "@mui/icons-material/ShowChart";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AssignmentReturnOutlinedIcon from "@mui/icons-material/AssignmentReturnOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";

export const DASHBOARD_PKEY = "dashboard";

export const DASHBOARD_TILES = [
  {
    pkey: "dashboard-sales-performance",
    title: "Sales over Time",
    description: "Revenue, orders, and channel mix over time.",
    Icon: ShowChartIcon,
  },
  {
    pkey: "dashboard-sales-history",
    title: "Sales by Product",
    description: "What each SKU sold over a selected period, by warehouse.",
    Icon: BarChartOutlinedIcon,
    path: "/sales-history",
  },
  {
    pkey: "late-ship",
    title: "Order Exceptions",
    description:
      "Identify unfulfilled orders and whether current on-hand inventory can satisfy them.",
    Icon: WarningAmberOutlinedIcon,
  },
  {
    pkey: "dashboard-lost-sales-analysis",
    title: "Lost Sales Analysis",
    description: "Estimated units lost to stockouts, with revenue at current selling prices.",
    Icon: TrendingDownIcon,
    path: "/lost-sales-analysis",
  },
  {
    pkey: "dashboard-returns-analysis",
    title: "Returns Analysis",
    description:
      "Understand return volume, value, rate, and processing age.",
    Icon: AssignmentReturnOutlinedIcon,
    path: "/returns-analysis",
  },
  {
    pkey: "dashboard-inventory-analysis",
    title: "Inventory Analysis",
    description:
      "On-hand, committed, and available-to-sell across the network.",
    Icon: Inventory2OutlinedIcon,
    path: "/inventory-analysis",
  },
  {
    pkey: "dashboard-inventory-health",
    title: "Inventory Health",
    description:
      "What opening, sales, POs, and receipts can currently say about a SKU at a warehouse — including the gaps.",
    Icon: HealthAndSafetyOutlinedIcon,
    path: "/inventory-health",
  },
  {
    pkey: "dashboard-inventory-risk",
    title: "Inventory Risk by Product",
    description:
      "Days of cover and revenue at risk by product for one warehouse.",
    Icon: ReportProblemOutlinedIcon,
    path: "/inventory-risk",
  },
  {
    pkey: "dashboard-purchase-order-analysis",
    title: "Purchase Order Analysis",
    description:
      "Which at-risk SKUs have a PO coming in time, what is overdue, and how reliable supplier dates are.",
    Icon: LocalShippingOutlinedIcon,
    path: "/purchase-order-analysis",
  },
  {
    pkey: "dashboard-supply-chain-cost-analysis",
    title: "Supply Chain Cost Analysis",
    description:
      "Find orders where supply-chain cost is a high percentage of Total Bill.",
    Icon: PercentOutlinedIcon,
    path: "/supply-chain-cost-analysis",
  },
  {
    pkey: "dashboard-open-to-buy-analysis",
    title: "Open to Buy Analysis",
    description: "Remaining budget available to commit against the plan.",
    Icon: ShoppingCartOutlinedIcon,
  },
  {
    pkey: "dashboard-inventory-turn-analysis",
    title: "Inventory Turn/Cash Flow Analysis",
    description: "How efficiently inventory converts back to cash.",
    Icon: SyncOutlinedIcon,
  },
  {
    pkey: "dashboard-inbound-optimization-analysis",
    title: "Inbound Optimization Analysis",
    description:
      "Supplier lead times, delays, and consolidation opportunities.",
    Icon: LocalShippingOutlinedIcon,
  },
  {
    pkey: "dashboard-fully-landed-cost-analysis",
    title: "Product Fully Landed Cost Analysis",
    description: "True cost per unit including freight, duties, and fees.",
    Icon: LocalOfferOutlinedIcon,
  },
  {
    pkey: "dashboard-product-at-risk-analysis",
    title: "Product At-risk Analysis",
    description: "SKUs trending toward a stockout or dead stock.",
    Icon: ReportProblemOutlinedIcon,
  },
];
